import { uploadBytes, ref, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../../utils/firebase.config';

export function useStorage() {
  const upload = async (path: string, data: File): Promise<string> => {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, data, { contentType: data.type });

    return getDownloadURL(storageRef);
  };

  const remove = async (path: string): Promise<void> => {
    const storageRef = ref(storage, path);

    await deleteObject(storageRef);
  };

  return { upload, remove };
}

export default useStorage;
